export default class extends HTMLElement {
  connectedCallback () {
    this.uniqueSelect = this.querySelector('select[name="unique_submitter_uuid"]')
    this.fixedEmailFields = this.querySelectorAll('.fixed-email-field')
    this.csvInput = this.querySelector('input[name="csv_file"]')
    this.previewDiv = document.getElementById('csv-preview')
    this.previewText = document.getElementById('preview-text')
    this.form = this.querySelector('form')

    // Bind methods
    this.toggleFixedEmails = this.toggleFixedEmails.bind(this)
    this.previewFile = this.previewFile.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)

    // Add event listeners
    if (this.uniqueSelect) {
      this.uniqueSelect.addEventListener('change', this.toggleFixedEmails)
    }

    if (this.csvInput) {
      this.csvInput.addEventListener('change', this.previewFile)
    }

    if (this.form) {
      this.form.addEventListener('submit', this.handleSubmit)
    }
  }

  disconnectedCallback () {
    if (this.uniqueSelect) {
      this.uniqueSelect.removeEventListener('change', this.toggleFixedEmails)
    }

    if (this.csvInput) {
      this.csvInput.removeEventListener('change', this.previewFile)
    }

    if (this.form) {
      this.form.removeEventListener('submit', this.handleSubmit)
    }
  }

  // Show/hide fixed email fields based on unique submitter selection
  toggleFixedEmails () {
    const selectedUuid = this.uniqueSelect.value

    this.fixedEmailFields.forEach(field => {
      const fieldUuid = field.dataset.uuid

      if (fieldUuid === selectedUuid) {
        // Hide the unique submitter's email field
        field.classList.add('hidden')
        field.querySelector('input').removeAttribute('required')
      } else {
        // Show fixed email fields for other submitters
        field.classList.remove('hidden')
        field.querySelector('input').setAttribute('required', 'required')
      }
    })
  }

  // Handle form submission - show loading state
  handleSubmit (event) {
    // Don't disable inputs before submit - that prevents their values from being sent
    // Instead, just show the loading overlay and let the form submit normally
    // The browser will handle disabling the submit button naturally

    // Show loading overlay if not already present
    if (!this.querySelector('.loading-overlay')) {
      const overlay = document.createElement('div')
      overlay.className = 'loading-overlay absolute inset-0 bg-base-200/80 flex items-center justify-center z-10'
      overlay.innerHTML = `
        <div class="text-center">
          <svg class="animate-spin h-8 w-8 mx-auto mb-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <p class="text-sm font-medium">Creating submissions...</p>
          <p class="text-xs text-gray-500">This may take a moment</p>
        </div>
      `
      this.style.position = 'relative'
      this.appendChild(overlay)
    }
  }

  // Preview CSV file contents
  previewFile (event) {
    const file = event.target.files[0]

    if (!file) {
      this.previewDiv.classList.add('hidden')
      return
    }

    const reader = new FileReader()

    reader.onload = (e) => {
      const content = e.target.result
      const lines = content.split(/\r?\n/).filter(line => line.trim() !== '')
      const count = lines.length

      if (count === 0) {
        this.previewText.textContent = 'Warning: File appears to be empty'
        this.previewDiv.classList.remove('hidden', 'alert-info')
        this.previewDiv.classList.add('alert-warning')
        return
      }

      // Show first few emails as preview
      const previewEmails = lines.slice(0, 3).join(', ')
      const moreText = count > 3 ? ` and ${count - 3} more` : ''

      this.previewText.textContent = `${count} submission${count === 1 ? '' : 's'} will be created. Preview: ${previewEmails}${moreText}`
      this.previewDiv.classList.remove('hidden', 'alert-warning')
      this.previewDiv.classList.add('alert-info')
    }

    reader.onerror = () => {
      this.previewText.textContent = 'Error reading file. Please try again.'
      this.previewDiv.classList.remove('hidden', 'alert-info')
      this.previewDiv.classList.add('alert-error')
    }

    reader.readAsText(file)
  }
}
